<template>
    <div class="card my-3">
        <div class="card-header">证书验证信息</div>
        <div class="card-body">
            <div class="form-group">
                <label class="font-weight-bold">姓名</label>
                <p class="form-control-plaintext">{{certInfo.studentName}}</p>
            </div>
            <div class="form-group">
                <label class="font-weight-bold">所属院校</label>
                <p class="form-control-plaintext">{{certInfo.collegeName}}</p>
            </div>
            <div class="form-group">
                <label class="font-weight-bold">项目批次</label>
                <p class="form-control-plaintext">{{certInfo.batchName}}</p>
            </div>
            <div class="form-group">
                <label class="font-weight-bold">项目名称</label>
                <p class="form-control-plaintext">{{certInfo.projectName}}</p>
            </div>
            <div class="form-group">
                <label class="font-weight-bold">培训基地</label>
                <p class="form-control-plaintext">{{certInfo.organName}}</p>
            </div>
            <div class="form-group">
                <label class="font-weight-bold">成绩</label>
                <p class="form-control-plaintext">{{certInfo.scoreLevelName}}</p>
            </div>
            <div class="form-group mb-0">
                <label class="font-weight-bold">证书编号</label>
                <p class="form-control-plaintext">{{certInfo.certificateId}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
export default {
    name: "ValidateCertificate",
    data: function () {
        return {
            studentClassId: this.$route.params.studentClassId,

            certInfo: {},
        };
    },
    mounted() {
        this.getStudentCertificateInfo();
    },
    methods: {
        getStudentCertificateInfo() {
            studyApi.certificate.getStudentCertificateInfo(this.studentClassId).then(res => {
                this.certInfo = res.data;
            });
        }
    }
}
</script>

<style scoped>

</style>